import React, { FC, useMemo } from 'react';
import { bucketMedia } from './helpers';
import MobileGalleryQuickLinkCollection from './quick_link_collection';

import { UnifiedLightboxTrackingEvents } from '@components/unified-lightbox/hooks/use-track-unified-lightbox';
import { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import Styles from './styles.scss';

interface MobileGalleryQuickLinksProps {
	media: Vendor.Media[];
	context?: ReturnType<typeof useInlineRfqForm>;
	trackingEvents?: UnifiedLightboxTrackingEvents;
}

export const MobileGalleryQuickLinks: FC<MobileGalleryQuickLinksProps> = (
	props,
) => {
	const { media } = props;

	const bucketedMedia = useMemo(() => bucketMedia(media), [media]);
	const filteredBucketedMedia = useMemo(
		() => Array.from(bucketedMedia).filter(([, value]) => value.length),
		[bucketMedia],
	);

	if (filteredBucketedMedia.length < 2) {
		return null;
	}

	return (
		<div className={Styles.quickLinkRow}>
			<MobileGalleryQuickLinkCollection
				mediaBuckets={filteredBucketedMedia}
				{...props}
			/>
		</div>
	);
};
